    // Get all category elements within the tabs container
    var categoryElements = document.querySelectorAll('.tabs .category');

    // Loop through each category element to add click event listener
    categoryElements.forEach(function(categoryElement) {
        categoryElement.addEventListener('click', function() {
            // Remove 'active' class from all category elements
            categoryElements.forEach(function(el) {
                el.classList.remove('active');
            });

            // Add 'active' class to the clicked category element
            categoryElement.classList.add('active');
        });
    });


    function extractElementFromHTML(htmlString, tagName) {
        // Create a temporary container element
        var tempContainer = document.createElement('div');
        tempContainer.innerHTML = htmlString;
    
        // Find the element by tag name
        var element = tempContainer.querySelector(tagName);
    
        // Return the element or null if not found
        return element;
    }

    async function loadData(event){
        try{
            event.preventDefault();
            let url = event.target.href;

            let headersList = {
                "Accept": "*/*",
                "User-Agent": "Thunder Client (https://www.thunderclient.com)"
            }
            
            let response = await fetch(`${url}`, { 
                method: "GET",
                headers: headersList
            });
            let data = await response.text();
            const existing_elem = document.querySelector('.past-releases-content-show')
            const existing_load_button = document.querySelector('.loadmore')
            const renderElem = extractElementFromHTML(data,'.past-releases-content-show')
            const renderLoadMore = extractElementFromHTML(data,'.loadmore')

            existing_elem.replaceWith(renderElem);

            if(renderLoadMore){
                existing_load_button.replaceWith(renderLoadMore);
            }else{
                let newDiv = document.createElement('div');
                newDiv.className = 'loadmore';
                existing_load_button.replaceWith(newDiv);
                
            }
        }catch(err){console.log(err)}
    }


    async function loadMore(event){
        try{
            event.preventDefault();
            let url = event.target.href;
            let headersList = {
                "Accept": "*/*",
                "User-Agent": "Thunder Client (https://www.thunderclient.com)"
            }
            
            let response = await fetch(`${url}`, { 
                method: "GET",
                headers: headersList
            });
            let data = await response.text();
            const existing_elem = document.querySelector('.past-releases-content-show')
            const existing_load_button = document.querySelector('.loadmore')
            const renderElem = extractElementFromHTML(data,'.past-releases-content-show')
            const renderLoadMore = extractElementFromHTML(data,'.loadmore')

            existing_elem.innerHTML += renderElem.innerHTML;

            if(renderLoadMore){
                existing_load_button.replaceWith(renderLoadMore);
            }else{
                let newDiv = document.createElement('div');
                newDiv.className = 'loadmore';
                existing_load_button.replaceWith(newDiv);
                
            }

        }catch(err){
        console.log(err)
        }
    }
    document.addEventListener("DOMContentLoaded", function() {
        const allTab = document.querySelector('.tabs .category.active');
        if (allTab) {
            loadData({ target: allTab, preventDefault: () => {} });
            
            // Set a delay of 0.5 seconds (500 milliseconds)
            setTimeout(() => {
                const pastRelease = document.querySelector('past-releases');
                if (pastRelease) {
                    pastRelease.style.display = 'block';
                }
            }, 600); // milliseconds delay
        }
    });